export const TAKTILE_ORG_ID = "9835812b-e5be-4fe1-b5a1-792de7d418bb";
export const DEMO_ORG_ID = "976b336b-e6b4-4904-8e20-1e27c33dc099";
